import { useCallback, useRef, useState } from 'react';
import axios from 'Axios';
import { X } from 'tabler-icons-react';
import { useSelector } from 'react-redux';
import { fileType, api, toastify, clx } from 'Utils';
import { ModalBox, Button } from 'Elements';
import styles from 'partials/modalbox/modal-form.module.scss';

export const ModalBoxUploadMedia = ({ isOpen, onClose, size, type }) => {
	const initialState = () => ({
		fields: {
			title: '',
			text: ''
		},
		fileUploaded: {},
		errors: []
	});

	const fileInput = useRef(null);
	const marker = useSelector((state) => state.marker);
	const [state, setState] = useState(initialState());

	const resetState = useCallback(() => {
		if (fileInput.current) {
			fileInput.current.value = null;
		}
		setState(initialState());
	}, []);

	const handleInput = (e) => {
		const fields = state.fields;
		const target = e.target;
		fields[target.name] = target.value;
		setState((prev) => ({
			...prev,
			fields
		}));
	};

	const clearSelected = () => {
		fileInput.current.value = null;
		setState((prev) => ({
			...prev,
			fileUploaded: {}
		}));
	};

	const handleUpload = () => {
		fileInput.current.click();
	};

	const handleChange = (e) => {
		const fileUploaded = e.target.files[0];
		setState((prev) => ({
			...prev,
			fileUploaded
		}));
	};

	const submitForm = () => {
		const data = {
			story_id: marker.selectedMarker.id,
			content_type: 'file',
			title: state.fields.title,
			file_type: type,
			file: state.fileUploaded
		};

		const formData = new FormData();
		for (const field in data) {
			formData.append(field, data[field] ?? '');
		}

		setState((prev) => ({
			...prev,
			disabled: true
		}));
		axios.post(api.storeStory, formData).then((res) => {
			const data = res.data;
			if (data.success) {
				setState((prev) => ({
					...prev,
					disabled: false
				}));
				toastify(
					<>
						<p>ثبت {fileType[type].title} با موفقیت انجام شد</p>
						<p>
							{fileType[type].title} شما بعد از تایید ناظر به
							نمایش در میآید
						</p>
					</>,
					'success'
				);
				resetState();
			}
		});
	};

	const handleSubmit = (e) => {
		submitForm();
		e.preventDefault();
	};

	return (
		<ModalBox
			isOpen={isOpen}
			onClose={onClose}
			size={size}
			onDestroy={resetState}>
			<header className={styles.header}>
				<h3
					className={
						styles.headerTitle
					}>{`افزودن ${fileType[type].title}`}</h3>
			</header>
			<div className={styles.body}>
				<form className={styles.form} onSubmit={handleSubmit}>
					<div className={styles.fieldset}>
						<label htmlFor="title" className={styles.label}>
							عنوان
						</label>
						<input
							id="title"
							name="title"
							type="text"
							placeholder={`عنوان ${fileType[type].title}`}
							className={styles.input}
							onChange={handleInput}
						/>
					</div>
					<div className={styles.fieldset}>
						<Button
							className={[styles.btnBorder, styles.btnFull].join(
								' '
							)}
							onClick={handleUpload}>
							{`انتخاب فایل ${fileType[type].title}`}
						</Button>
						<div className={styles.fieldRow}>
							<input
								hidden
								ref={fileInput}
								type="file"
								multiple={false}
								accept={fileType[type].accept}
								style={{ display: 'none' }}
								onChange={handleChange}
							/>
							{state.fileUploaded?.name && (
								<div
									className={[
										styles.fieldBox,
										'mt-10',
										styles.input_ltr
									].join(' ')}>
									<span
										className={[
											styles.text,
											styles.ellipsis
										].join(' ')}>
										{state.fileUploaded.name}
									</span>
									<Button
										title="حذف فایل"
										className={styles.removeSelected}
										onClick={clearSelected}>
										<X size="14" />
									</Button>
								</div>
							)}
						</div>
					</div>
					<div className={styles.fieldset}>
						<label htmlFor="text" className={styles.label}>
							توضیحات
						</label>
						<textarea
							id="text"
							name="text"
							placeholder={`اگر ${fileType[type].title} دارای توضیحات خاصی می باشد در این قسمت درج نمایید`}
							col="20"
							rows="10"
							className={[styles.input, styles.inputShort].join(
								' '
							)}
							onChange={handleInput}
						/>
					</div>
					<div className={clx(styles.fieldset, 'mt-30')}>
						<Button
							type="submit"
							className={clx(
								styles.submit,
								styles.submitFull
							)}>{`ثبت ${fileType[type].title}`}</Button>
					</div>
				</form>
			</div>
		</ModalBox>
	);
};
